import { render, staticRenderFns } from "./pop-up.vue?vue&type=template&id=fb62d380"
import script from "./pop-up.vue?vue&type=script&lang=js"
export * from "./pop-up.vue?vue&type=script&lang=js"
import style0 from "./pop-up.vue?vue&type=style&index=0&id=fb62d380&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports